import FullImage from './FullImage.js';

export default FullImage;